import styled from "styled-components"

export const StyledContent = styled.div`
  margin: 0 auto;
  max-width: 80rem;
  min-height: calc(100vh - 3.75rem);
  padding: 3.75rem 1.25rem 0;
  width: calc(100% - 2.5rem);
`
